import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ErrorHandlerService } from '../services/error-handler.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const errorHandler = inject(ErrorHandlerService);
  const token = authService.getToken();

  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Log error for debugging
      errorHandler.logError(error);

      // Auto-logout on token expired or unauthorized (skip on invite-accept so we can show a message)
      const isInviteAccept = router.url.includes('/invite/accept');
      const errorCode = errorHandler.getErrorCode(error);
      const isUnauthorized =
        errorCode === 'AUTH_TOKEN_EXPIRED' ||
        errorCode === 'AUTH_UNAUTHORIZED' ||
        error.status === 401;
      if (isUnauthorized && !isInviteAccept) {
        authService.logout();
        router.navigate(['/login']);
      }

      return throwError(() => error);
    })
  );
};
